(function($){
  $(document).ready(function() {

    const stickymenu = $("body:not(.admin) .site-header");
    const mystickymenu = stickymenu.stickybits({
        useStickyClasses: true,
        stickyBitStickyOffset: 0
    });
    window.addEventListener("resize", () => {
        mystickymenu.update();
    });

    const
        nav1 = $('.primary-header'),
        nav2 = $('.secondary-header'),
        recherche = $('#recherche'),
        formchercher = $('#formchercher');

    recherche.appendTo(nav1);


    /*
    * Responsive JS
    * http://www.javascriptkit.com/javatutors/matchmediamultiple.shtml
    */
    const bp = [0, 480, 768, 1024, 1240],
        mq_to_xs =    `(max-width: ${bp[1] - 1}px)`,                             // 0->479
        mq_xs_to_sm = `(max-width: ${bp[2] - 1}px) and (min-width: ${bp[1]}px)`, // 480->767
        mq_sm_to_md = `(max-width: ${bp[3] - 1}px) and (min-width: ${bp[2]}px)`, // 768->1023
        mq_md_to_lg = `(max-width: ${bp[4] - 1}px) and (min-width: ${bp[3]}px)`, // 1024->1239
        mq_from_lg =  `(min-width: ${bp[4]}px)`,                                 // 1240->++
        mqlist = [
            window.matchMedia(mq_to_xs),
            window.matchMedia(mq_xs_to_sm),
            window.matchMedia(mq_sm_to_md),
            window.matchMedia(mq_md_to_lg),
            window.matchMedia(mq_from_lg),
        ];

    function navTactile(){
        $('.has_submenu > .menu_link').click(function(e){
            e.preventDefault();
            $(this).delay(250).parent().toggleClass('open').siblings().removeClass('open');
        });
        formchercher.prependTo(recherche);
        recherche.appendTo(nav2);
        nav1.after(nav2);
        $('[data-mode="grille"]').click();
        $(':not(.minimize) > .filters-group-title').click();
        $('.filtres-dispos .minimizable').addClass('minimized');
    }

    // $(':not(.minimize) > .filters-group-title').on('click', function(){
    //     console.log('click', $(this));
    // });

    function navSouris(){
        $(".primary-header .has_submenu > .menu_link").click(function(e){
            // e.preventDefault();
            $(this).delay(250).parent().toggleClass('open').siblings().removeClass('open');
        });

        $('body').on('mouseout', '.menu_item', function(){
            $(this).removeClass('open');
        });

        $('.minimize > .filters-group-title').click();
        $('.filtres-dispos .minimizable').removeClass('minimized');

        recherche.appendTo(nav1);
        nav2.prependTo($('.site-header-container'));
        formchercher.appendTo($('body'));
    }

    function mediaqueryresponse(mql){
        if (mql.matches){
            if (mq_to_xs == mql.media){
                navTactile();
            }
            if (mq_xs_to_sm == mql.media){
                navTactile();
            }
            if (mq_sm_to_md == mql.media){
                navTactile();
            }
            if (mq_md_to_lg == mql.media){
                navSouris();
            }
            if (mq_from_lg == mql.media){
                navSouris();
            }
        }
    }


    // const xs = 480,
    //     sm = 768,
    //     md = 1024,
    //     lg = 1240;
    // function mediaqueryresponse(mql){
    //     const regexp_telPortrait = new RegExp('\\(max-width:\\s*' + (xs-1) + 'px\\)'),
    //           regexp_telPaysage = new RegExp('\\(max-width:\\s*' + (sm-1) + 'px\\) and \\(min-width:\\s*' + xs + 'px\\)'),
    //           regexp_tabletPortrait = new RegExp('\\(max-width:\\s*' + (md-1) + 'px\\) and \\(min-width:\\s*' + sm + 'px\\)'),
    //           regexp_tabletPaysage = new RegExp('\\(max-width:\\s*' + (lg-1) + 'px\\) and \\(min-width:\\s*' + md + 'px\\)'),
    //           regexp_ordi = new RegExp('\\(min-width:\\s*' + (lg) + 'px\\)');

    //     if (regexp_telPortrait.test(mql.media)){
    //         if (mql.matches){ // 320 -> 479
    //             navTactile();
    //         }
    //     }
    //     else if (regexp_telPaysage.test(mql.media)){
    //         if (mql.matches){ // 480 -> 767
    //             navTactile();
    //         }
    //     }
    //     else if (regexp_tabletPortrait.test(mql.media)){
    //         if (mql.matches){ // 768 -> 1023
    //             navTactile();
    //         }
    //     }
    //     else if (regexp_tabletPaysage.test(mql.media)){
    //         if (mql.matches){ // 1024 -> 1239
    //             navSouris();
    //         }
    //     }
    //     else if (regexp_ordi.test(mql.media)){
    //         if (mql.matches){ // 1240 -> *
    //             navSouris();
    //         }
    //     }
    // }

    for (var i=0; i<mqlist.length; i++){
      //console.log(mqlist[i]);
        mediaqueryresponse(mqlist[i]);
        mqlist[i].addListener(mediaqueryresponse);
    }


  })
})(jQuery);
